module.exports = require("@hsq/storage");